module.exports=function(n){return 1==n?"one":"other"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/relative-time-format/locale/nb/quantify.js
// module id = 662
// module chunks = 0